import { ActionBar as ActionBar$1, ActionBarMenu, ActionBarGroup, VerticalDivider, ActionBarIconButton } from './ActionBar.js';

const ActionBar = Object.assign(ActionBar$1, {
  IconButton: ActionBarIconButton,
  Divider: VerticalDivider,
  Group: ActionBarGroup,
  Menu: ActionBarMenu
});

export { ActionBar, ActionBar as default };
